var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaycoRisingColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #53284f;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #d9d9d6;\n      }\n\n      .cls-3 {\n        fill: #e22b2a;\n      }\n\n      .cls-4 {\n        fill: #f0a023;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "For_Color_Icons",
    "data-name": "For Color Icons",
    className: "cls-2",
    width: 200,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clayco_Rising",
    "data-name": "Clayco Rising"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m112.4,34.8c0,6.8-5.5,12.4-12.4,12.4s-12.4-5.6-12.4-12.4,5.5-12.4,12.4-12.4c6.8,0,12.4,5.5,12.4,12.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m105,176c-1.3-30.2-26-54.9-56.3-56.2h-9.6v10l9.5.1c25.2,1.2,45.1,21.2,46.3,46.3l.1,1.4h10v-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m151.2,119.8c-30.2,1.3-54.9,26-56.2,56.2l-.1,1.6h10l.1-1.4c1.2-25.1,21.1-45.1,46.3-46.3l10.5-.2v-9.8l-10.6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m131.9,176c-1.3-50.3-41.8-90.8-92.2-92.2h-1.5v10h1.5c44.8,1.3,80.9,37.4,82.2,82.2v1.5h10v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m160.3,83.9c-50.3,1.3-90.8,41.8-92.2,92.2v1.5h10v-1.5c1.3-44.8,37.4-80.9,82.2-82.2h1.5v-10h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m161.8,176c-.6-32.3-13.6-62.7-36.5-85.6-22.9-22.8-53.3-35.8-85.6-36.5h-1.5v10h1.5c29.6.6,57.5,12.6,78.5,33.6s32.9,48.9,33.6,78.5v1.5h10v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m160.3,53.9c-32.3.7-62.7,13.7-85.6,36.6s-35.9,53.3-36.5,85.6v1.5h10v-1.5c.6-29.6,12.6-57.5,33.6-78.5s48.9-32.9,78.5-33.6h1.5v-10l-1.5-.1Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaycoRisingColor);
export default __webpack_public_path__ + "static/media/ClaycoRising_Color.9b9936d1557ab590c99a0d3ff96510d5.svg";
export { ForwardRef as ReactComponent };